import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import utils from '../../../../utils/validateScanner.js'
import IRTException from '../../../../utils/IRTException.js';
import {
  BasicSelect
} from 'vue-search-select'
import user_tracker from '../../../../usertracker'
import { nudgeBus } from '@/utils/nudgeBus'

export default {
  name: 'generate-trip-sheet',
  mixins: [utils,IRTException],
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading
  },
  props: ['scheduleData', 'VehicleCapacityData'],
  data() {
    return {
      pageCountrule: 0,
      pageCount: 0,
      pageNo: 0,
      isLoadingSearch: false,
      isInscanSuccess:false,
      schedulesList: {},
      vehicleschedulesList: {},
      ConnectionTouchPoint: [],
      Stoppoints: [],
      username: '',
      uasertype: '',
      hubid: '',
      BagNo: '',
      BagNoError: '',
      tchIndex: 0,
      tchPointHubName: '',
      tchPointHubId: '',
      stopPointHubID: '',
      isDisabledNxt: false,
      isDisabledPrv: false,
      useremail: '',
      sSurfaceModeReasons: '',
      sSurfaceModeReasonsError: '',
      showReasonList: false,
      VehicleSealNo: '',
      CurrentKM: '',
      showcnfrmAllocation: false,
      showScanOut: true,
      scheduledBagCount: '',
      pendingMpsCount: '',
      showScannedOutBagsList: false,
      reloadingScannedOutBagsList: false,
      showModal: false,
      showModalForCargoPendingList: false,
      ShowMPSInscan: false,
      showValidationMSG: false,
      paperbagnum: '',
      parentawb: '',
      childmps: '',
      exceptionMsg: '',
      PendingScheduleBagsList: [],
      PendingScheduleShipmentsList: [],
      isLoadingBags: false,
      isLoadingShipments: false,
      hublist: [],
      cargohubitem: {
        id: '',
        text: ''
      },
      ecomhubitem: {
        id: '',
        text: ''
      },
      cargohubname: '',
      ecomhubname: '',
      hubLoading: '',
      ecomhubnameError: '',
      cargohubnameError: '',
      checkECOM: 0,
      checkCargo: 0,
      hubName: '',
      allowschedule: false,
      schedulemodal: false,
      //for paper work
      IsPaperWorkBag: false,
      paperbagno: '',
      PaperBagNoError: '',
      paperno: '',
      PaperNoError: '',
      paperstatus: '',
      vehiclecapacity: '',
      vehicleavailablecapacity: '',
      vehiclecurrentload: '',
      ExpectedB2BWeight:0,
      listpaperbagno: '',
      // fullErrorMessage: '',
      isBagData: false,
      showList: false,
      IsPaperNo: false,
      limitexceedmsg: '',
      isallowECOMload: false,
      cargolimitexceedmodal: false,
      isLimitExceed: false,
      IsAllowEcomShipment: false,
      isfullcapacity: false,
      cargolimitexceedmsg: '',
      cargoallowSchedule: false,
      isallowload: false,
      generatedPaperBagNoDetails: [],
      isExistBag: false,
      isReloadTable: false,
      IsAllow: false,
      PendingBagsCount: 0,
      ScheduledBagsCount: 0,
      VehicleCapacityDataList: [],
      PendingParentMPSDetailsList: [],
      isLoadingParentMPS: false,
      IsScheduleListData: '',
      destinationname: '',
      finalpaperbagno: '',
      FinalPaperBagNoError: '',
      token: '',
      invalidTokenModal: false,
      invalidtokenmsg: '',
      addmodalShow: false,
      reasonlist: [{
        text: "MISSED CONNECTION SHIPMENT RECD AFTER CUTOFF",
        value: 1
      }, {
        text: "OFF LOADED DUE TO DAMAGE CONDITION",
        value: 2
      },
      {
       text: "NOT CONNECTED SPACE CONSTRAINT",
       value: 3
     },
     {
      text: "CONSIGNMENT PARTIALLY CONNECTED",
      value: 4
    },
    {
     text: "NOT CONNECTED DUE TO E WAY BILL EXPIRED",
     value: 4
   }],
   selectedReason:{
     text: '',
     value: ''
   },
   reason:'',
   reasonErrorFlg:'0',
   reasonErrorMsg:'',
   isAllowPaperWorkConfirm:false,
   showMultipartShipmentModal:false,
   multipartShipmentData:[],
   showTripConfConnModel:false,
   tripConfConnData:[],
   timeoutHandler: 0,
   inputString:'',
   inputString1:'',
   manualInput:false,
   manualInscan:false,
   isLoadingSearchForCargoPending:false,
   isLoading:false,
   triptype: null,
   userData:[],
   vehiclesealdata: {},
   showMultipartBagModal:false,
   multipartBagData:[],
   isBikerFlag :false,
   restrictiontype:'outscan',
   PaperBagPendingOutscanListModel: false,
   PendingCount:'',
   OutScanCount:'',
   CountDetails:[],
   isConnectionRestricted:true,
   isHubRestricted:false,
   showsidebar:false,
   CountForTrip:[],
   AWBPendingOutscanListModel : false,
   PendingMpsListArr:[],
   Title:'',
   isAwbVisibility:false,
   showsidebutton:false,
   errormsgflag : false,
    scanPaperWorkBagParentAWB: false,
    isRemoveEvent: false,
    parentAWB: '',
    parentAWBError: '',
    childAWB:'',
    childAWBError:'',
    isAWBRemoveEvent: false,
    isRemoveRowLoader: false,
    userid: '',
    isLoadingB2BLoadPlan: false,
    b2bLoadPlanData: [],
    b2bLoadPlanResponse: {},
    showB2BConfirmModal: false,
    showB2BLoadPlanTab: false,
    isB2BLoadPlanActive: false,
    isLoadingB2BLoadPendency: false,
    b2bLoadPendencyData: [],
    b2bLoadPendencyResponse: {},
    showB2BPendencyConfirmModal: false,
    isB2BLoadPendencyActive: false,

          // Dock-In related
      dockId: '',
      dockbarcode:'',
      dockList: [],
      selectedDock: { value: '', text: '' },
      scannedDockBarcode: '',
      isDockIn: false,
      dockIdError: false,
      showChangeDockModal: false,
      newDockId: '',
      newDockBarcode:'',
      newDockSelected: { value: '', text: '' },
      newScannedDockBarcode: '',
      newDockIdError: false,
      changeDockReason: '',
      changeDockReasonError: false,
      selectedReasonError: false,
      isDockMandatory:false,
      getDockChangeReasonList:[],
      selectedDockChangeReason:{ value: '', text: '' },
      selectedDockChangeReasonError:'',
      dockLoading: false,

    }
  },
  computed: {
    hasScannedDockBarcode() {
      return !!(this.scannedDockBarcode && String(this.scannedDockBarcode).trim().length > 0);
    },
    hasSelectedDockOption() {
      return !!(this.selectedDock && this.selectedDock.value);
    },
    isDockDropdownDisabled() {
      if (this.isDockIn) return true;
      if (!this.hasScannedDockBarcode) return false;
      return !(this.selectedDock && this.selectedDock.value === this.scannedDockBarcode);
    },
    isScanDockBarcodeDisabled() {
      return this.isDockIn || this.hasSelectedDockOption;
    },
    hasNewScannedDockBarcode() {
      return !!(this.newScannedDockBarcode && String(this.newScannedDockBarcode).trim().length > 0);
    },
    hasSelectedNewDockOption() {
      return !!(this.newDockSelected && this.newDockSelected.value);
    },
    isNewDockDropdownDisabled() {
      if (!this.hasNewScannedDockBarcode) return false;
      return !(this.newDockSelected && this.newDockSelected.value === this.newScannedDockBarcode);
    },
    isNewScanDockBarcodeDisabled() {
      return this.hasSelectedNewDockOption;
    },
  },
  watch: {
    isDockMandatory(val) {
      if (val && !this.dockLoading) this.focusScanDockInput();
    },
    dockLoading(val) {
      if (!val && this.isDockMandatory && !this.isDockIn) this.focusScanDockInput();
    },
    showChangeDockModal(val) {
      if (val) this.focusNewDockScanInput();
    },
  },
  created: function() {
    this.$validator.extend('checkprefix', {
      getMessage: field => `Vehicle Seal Number Must Start With ${this.vehiclesealdata.sealprefix.join(" or ")}`,
      validate: value => {
        if(value && this.vehiclesealdata){
            let result = false
            for (let i = 0; i < this.vehiclesealdata.sealprefix.length; i++) {
              if (value.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase())) {
                  result = true;
                  break;
              }
            }
            return result;
         }else{
           return true;
         }
     }
   });
 },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
  },
  mounted() {
    //this.checkECOM = 0;
    //this.checkCargo = 0;
    //document.getElementById("tabECOM").checked = false;
    //document.getElementById("tabCargo").checked = true;
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userData = userdetail;
    this.uasertype = userdetail[0].utype;
    this.username = userdetail[0].FirstName;
    this.hubid = userdetail[0].HubId;
    this.useremail = userdetail[0].email;
    user_tracker.checkUserIP(userdetail[0], "GenerateTripSheet", this.$route.path);
    this.userid = parseInt(userdetail[0].userid, 10); 
    this.getHubName(userdetail[0].HubId);
    this.getHubDetails();
    this.showData();
    this.getTouchPoint();
    this.getvehiclesealdata();
    this.$refs.BagNo.focus();
    this.$router.replace({
      query: {
        '': null
      }
    });
    this.hubForManualRestriction();
    this.getPaperBagCount();

    // Get List of IRT Exception Type
		this.getExceptionTypes();

  this.getIsDockMandatory()

  },
  methods: {
    checkBarcodeForPaperBagOrParentAWB(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString1 += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString1.length <= 3) {
			 		this.manualInscan = true
			 		this.inputString1 = ''
		 		}else{
			 		this.manualInscan = false
			 		this.inputString1 = ''
		 		}
	 		}, 10)
 		},
    selectedReasonType(reasontype) {
      this.selectedReason = reasontype
      this.reason = reasontype.text
    },
    selectReasonCheck(){
      if(this.reason == undefined || this.reason == ''){
        this.reasonErrorFlg=1,
        this.reasonErrorMsg='Please select reason'
      }else {
        this.reasonErrorFlg=0,
        this.reasonErrorMsg=''
        this.isAllowPaperWorkConfirm=true
        this.addmodalShow = false;
        $(document.body).removeClass("modal-open");
        $(".modal-backdrop").remove();
        this.confirmAllocation();
      }
    },

    getvehiclesealdata(){
      this.vehiclesealdata = {}
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getVehicleSealConfiguration?hubid=' + this.hubid,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
          this.vehiclesealdata  =  result.data.ResponseData.find(x => x.connectionType ==  this.triptype);
          this.isHubRestricted  = result.data.ManualRestriction.restrictpaperbagcheck;
          this.showB2BLoadPlanTab = result.data.ManualRestriction.isb2bloadplanenabled || false;
          }
        })
    },
    getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
          } else {
            this.hubName = '';
          }
        }, error => {
          console.error(error)
        })
    },
    checkschedule() {
      this.checkECOM = 0;
      this.checkCargo = 0;
      document.getElementById("tabECOM").checked = false;
      document.getElementById("tabCargo").checked = false;
      this.ecomhubnameError = ''
      this.cargohubnameError = ''
      this.cargohubitem = {
        id: '',
        text: ''
      }
      this.ecomhubitem = {
        id: '',
        text: ''
      }
      this.cargohubname = ''
      this.ecomhubname = ''
      this.PendingScheduleBagsList = []
      this.PendingScheduleShipmentsList = []
    },
    openB2BLoadPlan() {
      this.showB2BConfirmModal = true;
    },
    confirmB2BLoadPlan() {
      this.showB2BConfirmModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      // Hide other tabs
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById("tabB2BLoadPlan").classList.add("active");
      // Hide pending bags/shipments and show B2B tab
      this.checkCargo = 0;
      this.checkECOM = 0;
      this.b2bLoadPlanData = [];
      this.b2bLoadPlanResponse = {};
      this.isLoadingB2BLoadPlan = true;
      this.isB2BLoadPlanActive = true;
      // HUB-8001: ensure the sibling B2B Load Pendency tab is hidden when opening B2B Load Plan.
      this.isB2BLoadPendencyActive = false;
      this.getB2BLoadPlanData();
    },
    cancelB2BLoadPlan() {
      this.showB2BConfirmModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    closeB2BLoadPlan() {
      this.isB2BLoadPlanActive = false;
      document.getElementById("tabB2BLoadPlan").className = document.getElementById("tabB2BLoadPlan").className.replace(" active", "");
      document.getElementById("PendingBagsOrShipment").style.display = "block";
      document.getElementById("tabPendingBagsOrShipment").classList.add("active");
      this.checkpending();
    },
    getB2BLoadPlanData(isRefresh) {
      this.isLoadingB2BLoadPlan = true;
      var availableCapacity = (this.VehicleCapacityDataList.Capacity || 0) - (this.VehicleCapacityDataList.CurrLoad || 0);
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'getPendingBagsForScheduleTrip',
        data: {
          "currentHubId": this.hubid[0],
          "connectionId": this.schedulesList.connectionid,
          "BagDestinationHubId": this.tchPointHubId,
          "BagDestinationHubName": this.tchPointHubName,
          "isB2BLoadPlanReq": true,
          "AvailableCapacity": availableCapacity,
          "tripId": String(this.schedulesList.tripid),
          "isDataRefreshRequested": isRefresh ? true : false
        },
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': 'WEB',
          'token': this.token
        }
      })
      .then(result => {
        this.isLoadingB2BLoadPlan = false;
        if (result.data.ResultCode == 100) {
          this.invalidTokenModal = false;
          this.b2bLoadPlanResponse = result.data.ResponseData;
          var loadPlan = result.data.ResponseData.loadPlan || [];
          this.b2bLoadPlanData.splice(0);
          for (var i = 0; i < loadPlan.length; i++) {
            this.b2bLoadPlanData.push(loadPlan[i]);
          }
          if (result.data.ReturnMessage.indexOf('Cached') > -1) {
            this.$alertify.success(result.data.ReturnMessage);
          }
        } else if (result.data.ResultCode == 401) {
          this.invalidTokenModal = true;
          this.invalidtokenmsg = result.data.ReturnMessage;
          this.$alertify.error(result.data.ReturnMessage);
        } else {
          this.invalidTokenModal = false;
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => {
        this.isLoadingB2BLoadPlan = false;
        console.error(error);
      });
    },
    // HUB-8078: format bin/pallet arrays (or scalar) for table/export/print display
    formatBinPallet(value) {
      if (value == null || value === '') {
        return '--';
      }
      if (Array.isArray(value)) {
        return value.length > 0 ? value.join(', ') : '--';
      }
      return value;
    },

    exportB2BLoadPlanExcel() {
      if (this.b2bLoadPlanData.length == 0) {
        this.$alertify.error('No data available to export');
        return;
      }
      var headers = ['AWB', 'Client Name', 'Bin Number', 'Pallet Number', 'MPS count', 'Weight (Kg)', 'Touchpoint Hub', 'Inscan time (1st MPS)', 'Days to PDD', 'Priority rank'];
      var rows = [];
      for (var i = 0; i < this.b2bLoadPlanData.length; i++) {
        var item = this.b2bLoadPlanData[i];
        rows.push([
          item.parentmps,
          item.clientAccountName || '--',
          this.formatBinPallet(item.bin),
          this.formatBinPallet(item.pallet),
          item.mpscount,
          item.weight,
          item.touchpointhubname || '--',
          item.inscantime ? moment(item.inscantime).format('DD-MM-YYYY HH:mm:ss') : '--',
          item.breachdays != null ? item.breachdays : '--',
          item.priorityrank
        ]);
      }
      var csvContent = [headers, ...rows].map(function(e) { return e.map(function(v) { return '"' + (v || '') + '"'; }).join(','); }).join('\n');
      var timestamp = moment().format('YYYY.MM.DD_HH.mm.ss');
      var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      var urlBlob = URL.createObjectURL(blob);
      link.setAttribute('href', urlBlob);
      link.setAttribute('download', 'B2BLoadPlan_' + this.schedulesList.tripid + '_' + timestamp + '.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(urlBlob);
    },
    printB2BLoadPlan() {
      if (this.b2bLoadPlanData.length == 0) {
        this.$alertify.error('No data available to print');
        return;
      }
      var printContent = '<html><head><title>B2B Load Plan - Trip ' + this.schedulesList.tripid + '_' + moment().format('DD-MM-YYYY_HH-mm-ss') + '</title>';
      printContent += '<style>body{font-family:Arial,sans-serif;font-size:12px;} table{width:100%;border-collapse:collapse;margin-bottom:20px;} th,td{border:1px solid #ddd;padding:6px 8px;text-align:center;} th{background:#ADD8E6;color:#000;} .header{margin-bottom:15px;} .header span{margin-right:30px;}</style>';
      printContent += '</head><body>';
      printContent += '<h3>B2B Load Plan</h3>';
      printContent += '<div class="header"><span><b>Connection:</b> ' + this.schedulesList.fullconnectionname + '</span>';
      printContent += '<span><b>Trip ID:</b> ' + this.schedulesList.tripid + '</span>';
      printContent += '<span><b>Vehicle:</b> ' + this.schedulesList.vehicleno + '</span>';
      printContent += '<span><b>Date:</b> ' + moment().format('DD-MMM-YYYY') + '</span></div>';
      var totalAWBs = this.b2bLoadPlanData.length;
      var totalMPS = this.b2bLoadPlanData.reduce(function(sum, item) { return sum + (item.mpscount || 0); }, 0);
      var totalWeight = this.b2bLoadPlanData.reduce(function(sum, item) { return sum + (item.weight || 0); }, 0);
      printContent += '<table style="margin-bottom:15px;"><tr><td><b>Total AWBs:</b> '  + totalAWBs + '</td><td><b>Total MPS count:</b> ' + totalMPS + '</td><td><b>Total weight (Kg):</b> ' + parseFloat(totalWeight).toFixed(2) + '</td><td><b>Avl. vehicle capacity (Kg):</b> ' + parseFloat(this.VehicleCapacityDataList.AvailableCapacity || 0).toFixed(2) + '</td></tr></table>';
      printContent += '<table><thead><tr><th>AWB</th><th>Client Name</th><th>Bin Number</th><th>Pallet Number</th><th>MPS count</th><th>Weight (Kg)</th><th>Touchpoint Hub</th><th>Inscan time (1st MPS)</th><th>Days to PDD</th><th>Priority rank</th></tr></thead><tbody>';
      for (var i = 0; i < this.b2bLoadPlanData.length; i++) {
        var item = this.b2bLoadPlanData[i];
        printContent += '<tr><td>' + item.parentmps + '</td><td>' + (item.clientAccountName || '--') + '</td><td>' + this.formatBinPallet(item.bin) + '</td><td>' + this.formatBinPallet(item.pallet) + '</td><td>' + item.mpscount + '</td><td>' + parseFloat(item.weight || 0).toFixed(2) + '</td><td>' + (item.touchpointhubname || '--') + '</td><td>' + (item.inscantime ? moment(item.inscantime).format('DD-MM-YYYY HH:mm:ss') : '--') + '</td><td>' + (item.breachdays != null ? item.breachdays : '--') + '</td><td>' + item.priorityrank + '</td></tr>';
      }
      printContent += '</tbody></table>';
      printContent += '</body></html>';
      var printWindow = window.open('', '_blank');
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    },
    // HUB-8001: Open B2B Load Pendency confirmation modal.
    openB2BLoadPendency() {
      this.showB2BPendencyConfirmModal = true;
    },
    // HUB-8001: Confirm — switch to Pendency tab and trigger fetch (mirrors confirmB2BLoadPlan).
    confirmB2BLoadPendency() {
      this.showB2BPendencyConfirmModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById("tabB2BLoadPendency").classList.add("active");
      this.checkCargo = 0;
      this.checkECOM = 0;
      this.b2bLoadPendencyData = [];
      this.b2bLoadPendencyResponse = {};
      this.isLoadingB2BLoadPendency = true;
      this.isB2BLoadPendencyActive = true;
      // HUB-8001: ensure the sibling B2B Load Plan tab is hidden when opening B2B Load Pendency.
      this.isB2BLoadPlanActive = false;
      this.getB2BLoadPendencyData();
    },
    // HUB-8001: Cancel — dismiss modal without action.
    cancelB2BLoadPendency() {
      this.showB2BPendencyConfirmModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    // HUB-8001: Close pendency tab and return to Pending Bags/Shipment tab (mirrors closeB2BLoadPlan).
    closeB2BLoadPendency() {
      this.isB2BLoadPendencyActive = false;
      document.getElementById("tabB2BLoadPendency").className = document.getElementById("tabB2BLoadPendency").className.replace(" active", "");
      document.getElementById("PendingBagsOrShipment").style.display = "block";
      document.getElementById("tabPendingBagsOrShipment").classList.add("active");
      this.checkpending();
    },
    // HUB-8001: Fetch full untrimmed pendency plan.
    // Reuses POST /getPendingBagsForScheduleTrip with skipCapacityTrim:true.
    // AvailableCapacity is intentionally omitted — server treats it as optional in this mode.
    getB2BLoadPendencyData(isRefresh) {
      this.isLoadingB2BLoadPendency = true;
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'getPendingBagsForScheduleTrip',
        data: {
          "currentHubId": this.hubid[0],
          "connectionId": this.schedulesList.connectionid,
          "BagDestinationHubId": this.tchPointHubId,
          "BagDestinationHubName": this.tchPointHubName,
          "isB2BLoadPlanReq": true,
          // HUB-8001: request the untrimmed pendency plan (server skips 1.1x AvailableCapacity trim).
          "skipCapacityTrim": true,
          // HUB-8001: AvailableCapacity intentionally omitted (optional when skipCapacityTrim:true).
          "tripId": String(this.schedulesList.tripid),
          "isDataRefreshRequested": isRefresh ? true : false
        },
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
          'requestfrom': 'WEB',
          'token': this.token
        }
      })
      .then(result => {
        this.isLoadingB2BLoadPendency = false;
        if (result.data.ResultCode == 100) {
          this.invalidTokenModal = false;
          this.b2bLoadPendencyResponse = result.data.ResponseData;
          var loadPlan = result.data.ResponseData.loadPlan || [];
          this.b2bLoadPendencyData.splice(0);
          for (var i = 0; i < loadPlan.length; i++) {
            this.b2bLoadPendencyData.push(loadPlan[i]);
          }
          if (result.data.ReturnMessage && result.data.ReturnMessage.indexOf('Cached') > -1) {
            this.$alertify.success(result.data.ReturnMessage);
          }
        } else if (result.data.ResultCode == 401) {
          this.invalidTokenModal = true;
          this.invalidtokenmsg = result.data.ReturnMessage;
          this.$alertify.error(result.data.ReturnMessage);
        } else {
          this.invalidTokenModal = false;
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => {
        this.isLoadingB2BLoadPendency = false;
        console.error(error);
      });
    },
    // HUB-8001: Export the full pendency list to CSV (filename prefix B2BLoadPendency_).
    exportB2BLoadPendencyExcel() {
      if (this.b2bLoadPendencyData.length == 0) {
        this.$alertify.error('No data available to export');
        return;
      }
      var headers = ['AWB', 'Client Name', 'Bin Number', 'Pallet Number', 'MPS count', 'Weight (Kg)', 'Touchpoint Hub', 'Inscan time (1st MPS)', 'Days to PDD', 'Priority rank'];
      var rows = [];
      for (var i = 0; i < this.b2bLoadPendencyData.length; i++) {
        var item = this.b2bLoadPendencyData[i];
        rows.push([
          item.parentmps,
          item.clientAccountName || '--',
          this.formatBinPallet(item.bin),
          this.formatBinPallet(item.pallet),
          item.mpscount,
          item.weight,
          item.touchpointhubname || '--',
          item.inscantime ? moment(item.inscantime).format('DD-MM-YYYY HH:mm:ss') : '--',
          item.breachdays != null ? item.breachdays : '--',
          item.priorityrank
        ]);
      }
      var csvContent = [headers, ...rows].map(function(e) { return e.map(function(v) { return '"' + (v || '') + '"'; }).join(','); }).join('\n');
      var timestamp = moment().format('YYYY.MM.DD_HH.mm.ss');
      var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      var link = document.createElement('a');
      var urlBlob = URL.createObjectURL(blob);
      link.setAttribute('href', urlBlob);
      link.setAttribute('download', 'B2BLoadPendency_' + this.schedulesList.tripid + '_' + timestamp + '.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(urlBlob);
    },
    // HUB-8001: Print-ready pendency view (filename prefix B2BLoadPendency_).
    printB2BLoadPendency() {
      if (this.b2bLoadPendencyData.length == 0) {
        this.$alertify.error('No data available to print');
        return;
      }
      var printContent = '<html><head><title>B2BLoadPendency_' + this.schedulesList.tripid + '_' + moment().format('DD-MM-YYYY_HH-mm-ss') + '</title>';
      printContent += '<style>body{font-family:Arial,sans-serif;font-size:12px;} table{width:100%;border-collapse:collapse;margin-bottom:20px;} th,td{border:1px solid #ddd;padding:6px 8px;text-align:center;} th{background:#ADD8E6;color:#000;} .header{margin-bottom:15px;} .header span{margin-right:30px;}</style>';
      printContent += '</head><body>';
      printContent += '<h3>B2B Load Pendency</h3>';
      printContent += '<div class="header"><span><b>Connection:</b> ' + this.schedulesList.fullconnectionname + '</span>';
      printContent += '<span><b>Trip ID:</b> ' + this.schedulesList.tripid + '</span>';
      printContent += '<span><b>Vehicle:</b> ' + this.schedulesList.vehicleno + '</span>';
      printContent += '<span><b>Date:</b> ' + moment().format('DD-MMM-YYYY') + '</span></div>';
      var totalAWBs = this.b2bLoadPendencyData.length;
      var totalMPS = this.b2bLoadPendencyData.reduce(function(sum, item) { return sum + (item.mpscount || 0); }, 0);
      var totalWeight = this.b2bLoadPendencyData.reduce(function(sum, item) { return sum + (item.weight || 0); }, 0);
      printContent += '<table style="margin-bottom:15px;"><tr><td><b>Total AWBs:</b> ' + totalAWBs + '</td><td><b>Total MPS count:</b> ' + totalMPS + '</td><td><b>Total weight (Kg):</b> ' + parseFloat(totalWeight).toFixed(2) + '</td><td><b>Avl. vehicle capacity (Kg):</b> ' + parseFloat(this.VehicleCapacityDataList.AvailableCapacity || 0).toFixed(2) + '</td></tr></table>';
      printContent += '<table><thead><tr><th>AWB</th><th>Client Name</th><th>Bin Number</th><th>Pallet Number</th><th>Bin Number</th><th>Pallet Number</th><th>MPS count</th><th>Weight (Kg)</th><th>Touchpoint Hub</th><th>Inscan time (1st MPS)</th><th>Days to PDD</th><th>Priority rank</th></tr></thead><tbody>';
      for (var i = 0; i < this.b2bLoadPendencyData.length; i++) {
        var item = this.b2bLoadPendencyData[i];
        printContent += '<tr><td>' + item.parentmps + '</td><td>' + (item.clientAccountName || '--') + '</td><td>' + this.formatBinPallet(item.bin) + '</td><td>' + this.formatBinPallet(item.pallet) + '</td><td>' + this.formatBinPallet(item.bin) + '</td><td>' + this.formatBinPallet(item.pallet) + '</td><td>' + item.mpscount + '</td><td>' + parseFloat(item.weight || 0).toFixed(2) + '</td><td>' + (item.touchpointhubname || '--') + '</td><td>' + (item.inscantime ? moment(item.inscantime).format('DD-MM-YYYY HH:mm:ss') : '--') + '</td><td>' + (item.breachdays != null ? item.breachdays : '--') + '</td><td>' + item.priorityrank + '</td></tr>';
      }
      printContent += '</tbody></table>';
      printContent += '</body></html>';
      var printWindow = window.open('', '_blank');
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    },
    checkpending() {
      this.checkECOM = 0;
      this.checkCargo = 1;
      document.getElementById("tabECOM").checked = false;
      document.getElementById("tabCargo").checked = true;
    },
    checkcargo() {
      document.getElementById("tabECOM").checked = false;
      document.getElementById("tabCargo").checked = true;
      this.checkECOM = 0;
      this.checkCargo = 1;
      this.ecomhubnameError = ''
      this.ecomhubitem = {
        id: '',
        text: ''
      }
      this.ecomhubname = ''
      this.PendingScheduleShipmentsList = []
    },
    checkeco() {
      document.getElementById("tabCargo").checked = false;
      document.getElementById("tabECOM").checked = true;
      this.checkCargo = 0;
      this.checkECOM = 1;
      this.cargohubnameError = ''
      this.cargohubitem = {
        id: '',
        text: ''
      }
      this.cargohubname = ''
      this.PendingScheduleBagsList = []
    },
    getHubDetails() {
      this.input = {
        hubids: this.hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.hubdata = result.data.ResponseData[0];
          } else {
            this.hubcode = '';
          }
        }, error => {
          console.error(error)
        })
    },

    showData() {
      this.schedulesList = this.$route.query.scheduleData;
      this.isBikerFlag = this.$route.query.scheduleData.isbikertrip;

      if (this.schedulesList.triptype == 'network-local') {
        this.triptype = 4
      } else if (this.schedulesList.triptype == 'NetworkBased') {
        this.triptype = 0
      } else if (this.schedulesList.triptype == 'linehaulbiker') {
        this.triptype = 6
      }
      this.VehicleCapacityDataList = this.$route.query.VehicleCapacityData
      if (this.schedulesList.triptype == 'network-local') {
        this.destinationname = this.schedulesList.fullconnectionname.split('-')
        this.tchPointHubName = this.destinationname[0]
      }
      this.IsScheduleListData = typeof this.schedulesList === 'object' && this.schedulesList !== null
    },
    logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
    closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
    getVehicleCapacityDetails() {
      let vehicleType = '';
      if(this.isBikerFlag){
        vehicleType ='Biker'
      }
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getVehicleCapacityforSchedule?ConnectionScheduleMasterId=' + this.schedulesList.connectionschedulemasterid + '&TripID=' + this.schedulesList.tripid + '&CurrentHubId=' + this.hubid[0] + '&vehicleType=' + vehicleType,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.VehicleCapacityDataList = result.data.ResponseData
            this.invalidTokenModal = false
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.VehicleCapacityDataList = []
            this.invalidTokenModal = false
          }
        }, error => {
          console.error(error)
        })
    },
    getTouchPoint() {
      this.input = ({
        "connectionid": this.schedulesList.connectionid,
        "currenthubid": this.hubid[0]
      })
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'getConnectionTouchPoint',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.ConnectionTouchPoint = result.data.ResponseData;
            this.isConnectionRestricted = result.data.ResponseData[0].isPaperWorkScanEnabled;
            this.isConnectionRestricted = true;
            this.Stoppoints = this.ConnectionTouchPoint[0].Stoppoints;
            if (this.Stoppoints.length <= 0) {
              console.log("stop points are empty");
            }
            if (this.tchIndex == 0) {
              this.showReasonList = false;
              this.isDisabledPrv = true;
              this.tchPointHubName = this.Stoppoints[this.tchIndex].StopPointName;
              this.tchPointHubId = this.Stoppoints[this.tchIndex].StopPointHubId;
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.ConnectionTouchPoint = [];
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.getPendingScheduledBagCount();
        }, error => {
          console.error(error)
        })
    },
    prvTouchPoint(e) {
      this.showReasonList = false;
      if (this.tchIndex == 0) {
        this.tchPointHubName = this.Stoppoints[this.tchIndex].StopPointName;
        this.tchPointHubId = this.Stoppoints[this.tchIndex].StopPointHubId;
        this.isDisabledPrv = true;
      } else {
        this.isDisabledPrv = false;
        this.isDisabledNxt = false;
        this.tchIndex = this.tchIndex - 1;
        this.tchPointHubName = this.Stoppoints[this.tchIndex].StopPointName;
        this.tchPointHubId = this.Stoppoints[this.tchIndex].StopPointHubId;
      }
      this.getAllHub()
      this.getPendingScheduledBagCount();
      e.preventDefault()
    },
    nxtTouchPoint(e) {
      this.showReasonList = false;
      if (this.tchIndex == this.Stoppoints.length - 1) {
        this.isDisabledNxt = true;
      } else {
        this.isDisabledPrv = false;
        this.isDisabledNxt = false;
        this.tchIndex = this.tchIndex + 1;
        this.tchPointHubName = this.Stoppoints[this.tchIndex].StopPointName;
        this.tchPointHubId = this.Stoppoints[this.tchIndex].StopPointHubId;
      }
      this.getAllHub()
      this.getPendingScheduledBagCount();
      e.preventDefault()
    },
    backtoList() {
      let routeData = this.$router.push({
        path: "NetworkManagement"
      })
    },
    CheckBagNoError() {
      if (this.BagNo == '') {
        this.manualInput =  false
        this.BagNoError = "The Bag No field is required."
      } else {
        this.BagNoError = ""
      }
    },
    clearsSurfaceModeReasonsError() {
      if (this.showReasonList == true && this.sSurfaceModeReasons == '') {
        this.sSurfaceModeReasonsError = "The Surface Mode Reasons field is required."
      } else {
        this.sSurfaceModeReasonsError = ""
      }
    },
    scanOutBag(isSchedule) {
      this.getvehiclesealdata();
      if (this.BagNo == '') {
        this.manualInput = false
        this.BagNoError = "The Bag No field is required."
        return false
      } else if (this.showReasonList == true && this.sSurfaceModeReasons == '') {
        this.sSurfaceModeReasonsError = "The Surface Mode Reasons field is required."
        return false
      } else {
        this.BagNoError = ""
        this.sSurfaceModeReasonsError = ""
      }
      if (this.IsAllowEcomShipment == true && this.isLimitExceed == false) {
        this.allowschedule = true
        this.isallowECOMload = false
      } else if (this.IsAllowEcomShipment == true && this.isLimitExceed == true) {
        this.isallowECOMload = true
        this.allowschedule = false
      } else {
        this.allowschedule = false
        this.isallowECOMload = false
      }
      // if (isSchedule == 1) {
      //   this.allowschedule = true
      // } else {
      //   this.allowschedule = false
      // }

      this.isLoadingSearch = true;

      this.input = ({
        "bagNumber": this.BagNo,
        "networkBasedVehicleNo": this.schedulesList.vehicleno,
        "vendorId": this.schedulesList.vendorid,
        "connectionId": this.schedulesList.connectionid,
        "routeMode": this.schedulesList.routemode,
        "currentHubId": this.hubid[0],
        "currentHubName": this.hubdata.HubName,
        "connectionScheduleMasterId": this.schedulesList.connectionschedulemasterid,
        "sSurfaceModeReasons": this.sSurfaceModeReasons,
        "stopPointHubID": this.tchPointHubId,
        "stopPointHubName":this.tchPointHubName,
        "inScanFromDevice": "WEB",
        "isAllowBagOutscan": false,
        "createdBy": this.useremail,
        "allowSchedule": this.allowschedule,
        "isAllowExceedWeight": this.isallowECOMload,
        "isRoundTrip": this.schedulesList.isroundtrip == null ? false : this.schedulesList.isroundtrip,
        "isManualEntry": this.manualInput,
        "userId": this.userid

      })
      if(this.isBikerFlag ){
        this.input.isBikerTrip = this.isBikerFlag;


      }

      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'tripScanoutBag',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          // this.showConfirmAllocation();
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.getPaperBagCount();
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage);
            if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
            this.BagNo = '';
            this.manualInput = false
            this.BagNoError = '';
            if(result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0){
                this.colorCode = result.data.lossCategorization.colorCode;
                this.colorIcon = result.data.lossCategorization.icon;
              }
            user_tracker.checkUserIP(this.userData[0], "TripScanoutBag", this.$route.path,this.input)
            this.$refs.BagNo.focus();
            this.$validator.reset();
            this.showConfirmAllocation();
            this.showReasonList = false;
            this.sSurfaceModeReasons = '';
          }
          else if (result.data.Trackingno) {
            // IRT Exception Error & Tracking No
            this.openIRTExceptionModal(this.BagNo, result.data.ReturnMessage, result.data.Trackingno);

            this.$alertify.error(result.data.ReturnMessage)
          }
          else if (result.data.ResultCode == 107) {
            this.invalidTokenModal = false
            this.showReasonList = true;
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 105) {
            this.invalidTokenModal = false
            this.showModal = true;
            this.showReasonList = false
            this.sSurfaceModeReasons = ''
            this.exceptionMsg = result.data.ReturnMessage;
          } else if (result.data.ResultCode == 106) {
            this.invalidTokenModal = false
            this.limitexceedmsg = result.data.ReturnMessage
            this.schedulemodal = true
            this.isLimitExceed = false
            this.showReasonList = false
            this.sSurfaceModeReasons = ''
          } else if (result.data.ResultCode == 104) {
            this.isLimitExceed = true
            this.invalidTokenModal = false
            this.limitexceedmsg = result.data.ReturnMessage
            this.schedulemodal = true
            this.showReasonList = false
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.showReasonList = false
            this.sSurfaceModeReasons = ''
            this.$alertify.error(result.data.ReturnMessage)
          } else if(result.data.ResultCode == 110){
            this.multipartShipmentData=result.data.ResponseData
            this.showMultipartShipmentModal=true
            this.$alertify.error(result.data.ReturnMessage)
          } else if(result.data.ResultCode == 113 ){
            this.multipartBagData=result.data.ResponseData
            this.showMultipartBagModal=true
            this.$alertify.error(result.data.ReturnMessage)
          }
          else {
            this.invalidTokenModal = false
            this.limitexceedmsg = ''
            this.schedulemodal = false
            this.isLimitExceed = false
            this.showReasonList = false
            this.sSurfaceModeReasons = ''
            this.$toast.error(result.data.ReturnMessage, { timeout: 10000, position: 'bottom-right' });
          }
          user_tracker.checkUserIP(this.userData[0], "TripScanoutBag", this.$route.path,this.input)
        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })
    },
    closeScheduleModal() {
      this.schedulemodal = false
    },
    showConfirmAllocation(e) {
      this.scheduledBagCount = [];
      this.reloadingScannedOutBagsList = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getSchedulebagsForTrip?connectionschedulemasterid=' + this.schedulesList.connectionschedulemasterid + '&currenthubid=' + this.hubid[0] + '&connectionid=' + this.schedulesList.connectionid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          // this.showcnfrmAllocation = true;
          // this.showScanOut = false;
          // this.reloadingScannedOutBagsList = false;
          // this.showScannedOutBagsList = true;
          // this.scheduledBagCount = {
          //   "count": 1,
          //   "weight": 3,
          //   "Data": [{
          //     "connectionid": 99,
          //     "createddate": "2019-07-05T10:26:24.445Z",
          //     "createdby": "test34343@xpressbees.com",
          //     "bagno": "xb-425",
          //     "type": "Bag",
          //     "status": "Scheduled",
          //     "volumetricweight": "2.20",
          //     "chargeableweight": "3.00",
          //     "physicalweight": 3,
          //     "originhubid": 401,
          //     "originhubname": "PNQ/DPR",
          //     "destinationhubid": 1567,
          //     "destinationhubname": "Vadodara/KRB"
          //   }]
          // }
          // return false
          // this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.showcnfrmAllocation = true;
            this.reloadingScannedOutBagsList = false;
            this.showScannedOutBagsList = true;
            this.scheduledBagCount = result.data.ResponseData
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.reloadingScannedOutBagsList = false;
            this.showScannedOutBagsList = false;
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
      if (e) e.preventDefault();
    },
    removeBagScheduledBag() {
      if(!this.childAWB) {
        this.childAWBError = 'The Bag/MPS field is required.'; return;
      }
      this.childAWBError = '';
      this.isRemoveRowLoader = true;
      this.input = ({
        "parentBagNo": this.childAWB,
        "userHubID": this.hubid[0],
        "lastModifiedBy": this.useremail,
        "processLocationName": this.hubName,
        "connectionName": this.schedulesList.fullconnectionname,
        "connectionScheduleMasterId": this.schedulesList.connectionschedulemasterid,
        "statusMarkedFrom": 'WEB'
      })
      // console.log(this.input);
      // return false
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'tripRemoveBagShipment',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.isRemoveRowLoader = false; 
          if (result.data.ResultCode == 100) {
            this.childAWB = '';
            this.invalidTokenModal = false
            this.$alertify.success(result.data.ReturnMessage)
            this.showConfirmAllocation();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
            this.showConfirmAllocation();
          }
          this.childAWB = '';
        }, error => {
          this.isRemoveRowLoader = false;
          console.error(error)
        })
    },
    clearFinalPaperBagNoError() {
      if (this.finalpaperbagno == '') {
        this.FinalPaperBagNoError = "The Paper Bag No field is required."
      } else {
        this.FinalPaperBagNoError = ''
      }
    },
    scanOutPaperBag() {
      if (this.finalpaperbagno == '') {
        this.FinalPaperBagNoError = "The Paper Bag No field is required."
        return false;
      } else {
        this.FinalPaperBagNoError = ''
        this.input = ({
          "PaperBagNo": this.finalpaperbagno,
          "ConnectionScheduleMasterID": this.schedulesList.connectionschedulemasterid,
          "UserHubID": this.hubid[0],
          "UserHubName": this.hubdata.HubName,
          "LastModifiedBy": this.useremail,
          "isManualEntry": this.manualInput,
          "isConnectionRestricted":this.isConnectionRestricted,
          "isHubRestricted" :this.isHubRestricted
        })
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'paperLessWorkScanOut',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.$alertify.success(result.data.ReturnMessage)
              this.finalpaperbagno = ''
              this.FinalPaperBagNoError = ''
              this.manualInput = false
            } else {
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.getPaperBagCount();
          }, error => {
            console.error(error)
          })
      }
    },
    onSubmitPaperBag: function(PaperBagTab) {
      this.$validator.validateAll('PaperBagTab').then((result) => {
        if (!result) {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    resetPaperBag() {
      this.finalpaperbagno = '';
      this.FinalPaperBagNoError = '';
      this.getPaperBagCount();
    },
    confirmAllocation() {
      if(!this.VehicleSealNo) return;

      // if(this.VehicleSealNo != ''){
      //   let sealno = this.validatebuttons()
      //   if(!sealno){
      //     this.$alertify.error('Vehicle Seal Number Must Start With '+ this.vehiclesealdata.sealprefix.join(" or "));
      //     return false
      //   }
      // }

      if (this.CurrentKM == '') {
        return false
      }
      if (this.schedulesList.triptype == 'network-local') {
        var triptype = 4
      } else if (this.schedulesList.triptype == 'NetworkBased') {
        var triptype = 0
      } else if (this.schedulesList.triptype == 'linehaulbiker') {
        var triptype = 6
      }
      if(this.reason && this.isAllowPaperWorkConfirm ==true){
        this.input = ({
          "connectionScheduleMasterId": this.schedulesList.connectionschedulemasterid,
          "currentHubId": this.hubid[0],
          "hubCode": this.hubdata.HubCode,
          "hubName": this.hubdata.HubName,
          "vehicleSealNo": this.VehicleSealNo,
          "tripId": this.schedulesList.tripid,
          "totalNoOfBags": this.scheduledBagCount.count != undefined ? this.scheduledBagCount.count : 0,
          "currentKm": this.CurrentKM,
          "imageUrl": "",
          "createdBy": this.useremail,
          "tripType": triptype,
          "isAllowPaperWorkConfirm":true,
          "confirmAllocationReason":this.reason
        })
      }
      else{
      this.input = ({
        "connectionScheduleMasterId": this.schedulesList.connectionschedulemasterid,
        "currentHubId": this.hubid[0],
        "hubCode": this.hubdata.HubCode,
        "hubName": this.hubdata.HubName,
        "vehicleSealNo": this.VehicleSealNo,
        "tripId": this.schedulesList.tripid,
        "totalNoOfBags": this.scheduledBagCount.count != undefined ? this.scheduledBagCount.count : 0,
        "currentKm": this.CurrentKM,
        "imageUrl": "",
        "createdBy": this.useremail,
        "tripType": triptype,
        "isAllowPaperWorkConfirm":false,
        "isConnectionRestricted":this.isConnectionRestricted,
        "isHubRestricted":this.isHubRestricted,
        "statusMarkedFrom":"web"
      })
    }

    this.isLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'tripConfirmConnection',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.isLoading = false;
          this.isAllowPaperWorkConfirm=false;
          this.reason='';
          this.addmodalShow = false;
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.resetAll();
            this.$alertify.success(result.data.ReturnMessage)
            this.$router.push('/NetworkManagement')
          } else if (result.data.ResultCode == 104) {
            this.FinalPaperBagNoError = "The Paper Bag No field is required."
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else if (result.data.ResultCode == 105) {
            this.addmodalShow = true
          }
          else if(result.data.ResultCode == 110){
            this.tripConfConnData=result.data.ResponseData
            this.showTripConfConnModel=true
            this.$alertify.error(result.data.ReturnMessage)
          }
          else
            {
            this.invalidTokenModal = false
            this.FinalPaperBagNoError = ''
            this.VehicleSealNo = '';
            this.$alertify.error(result.data.ReturnMessage)
          }
          user_tracker.checkUserIP(this.userData[0], "tripConfirmConnection", this.$route.path,this.input)
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    cancelAllocation(e) {
      this.VehicleSealNo = '';
      this.showcnfrmAllocation = false;
      this.showScanOut = true;
      this.$validator.reset();
      e.preventDefault();
    },
    closeStatusModal() {
      this.selectedReason={
        text:'',
        value:''
      }
      this.reason='';
      this.reasonErrorFlg='';
      this.addmodalShow = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    resetAll() {
      this.parentawb = ''
      this.childmps = '';
      this.VehicleSealNo = '';
      this.CurrentKM = '';
      this.exceptionMsg = '';
      this.showModal = false;
      this.$validator.reset();
      this.$refs.BagNo.focus();
      this.BagNo = '';
      this.manualInput = false
      this.BagNoError = '';
      this.sSurfaceModeReasons = "";
      this.sSurfaceModeReasonsError = "";
      this.finalpaperbagno = '';
      this.FinalPaperBagNoError = '';
      this.isLoading =false;
      this.showsidebutton=false;
      const field = document.getElementById("VehicleSealNo");
      if (field) field.disabled = false;
      // Reset dock on trip close
      this.resetDock();
      this.isDockIn = false;
    },
    closeModalForCagoPending() {
      this.showModal = false;
      this.exceptionMsg = '';
      this.ShowMPSInscan = false;
      this.isLoadingSearchForCargoPending=false;
      this.showModalForCargoPendingList = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.$validator.reset();
    },
    onSubmit: function(event) {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pageNo = 0
          // @click="Inscan"

        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    onSubmitSealNo: function(Tab) {
      this.$validator.validateAll('Tab').then((result) => {
        if (result) {
          this.pageNo = 0
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    //open vendor and billing details tab
    openTab(evt, tabName) {
      this.isB2BLoadPlanActive = false;
      // HUB-8001: mirror the B2B Load Plan cleanup so the pendency panel is
      // hidden when the user switches to Pending/Schedule Bags/Shipment.
      // Bugbot review: HUB-8001 L759 (two tabcontent blocks visible).
      this.isB2BLoadPendencyActive = false;
      this.cargohubitem = {
        id: '',
        text: ''
      }
      this.ecomhubitem = {
        id: '',
        text: ''
      }
      this.getAllHub();

      this.PendingScheduleBagsList = []
      this.PendingScheduleShipmentsList = []
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(tabName).style.display = "block";
      evt.currentTarget.className += " active";
      if (tabName == "ECOM") {
        document.getElementById("tabECOM").classList.add("active");
      } else {
        document.getElementById("tabECOM").className.replace("active", "");
      }
      if (tabName == "Cargo") {
        document.getElementById("tabCargo").classList.add("active");
      } else {
        document.getElementById("tabCargo").className.replace("active", "");
      }
      if (tabName == "ScheduleBagsORShipment") {
        document.getElementById("tabScheduleBagsORShipment").classList.add("active");
      } else {
        document.getElementById("tabScheduleBagsORShipment").className.replace("active", "");
      }
      if (tabName == "PendingBagsOrShipment") {
        document.getElementById("tabPendingBagsOrShipment").classList.add("active");
      } else {
        document.getElementById("tabPendingBagsOrShipment").className.replace("active", "");
      }
    },
    getAllHub() {
      this.hublist = [];
      this.hubLoading = 'Loading Hub...'
      this.input = ({})
      var tchPointHubName = this.tchPointHubName.split('(')
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'fetchHubsByInScanHubId?inScanHubId=' + this.tchPointHubId + '&connectionId=' + this.schedulesList.connectionid + '&inScanHubName=' + tchPointHubName[0],
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubDetails = []
          var HubDetails = result.data.ResponseData
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            for (var i = 0; i < HubDetails.length; i++) {
              this.hublist.push({
                "id": HubDetails[i].hubid,
                "text": HubDetails[i].hubname,
                // "text": HubDetails[i].hubname + '(' + HubDetails[i].hubid + ')',
              })
            }
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.ecomhubnameError = result.data.ReturnMessage
            // this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.hubLoading = ''
          console.error(error)
        })
    },
    SelectCargoHub(cargohubitem) {
      this.cargohubitem = cargohubitem
      this.cargohubname = cargohubitem.text
      if (this.cargohubname == '') {
        this.cargohubnameError = " Select Hub Name"
      } else {
        this.cargohubnameError = ""
      }
    },
    SelectECOMHub(ecomhubitem) {
      this.ecomhubitem = ecomhubitem
      this.ecomhubname = ecomhubitem.text
      if (this.ecomhubname == '') {
        this.ecomhubnameError = " Select Hub Name"
      } else {
        this.ecomhubnameError = ""
      }
    },
    getPendingBags() {
      if (this.cargohubname == '') {
        this.cargohubnameError = " Select Hub Name"
        return false;
      } else {
        this.cargohubnameError = ''
        this.isLoadingBags = true
        this.PendingScheduleBagsList = []
        this.input = ({
          "currentHubId": this.hubid[0],
          "connectionId": this.schedulesList.connectionid,
          "BagDestinationHubId": this.cargohubitem.id,
          "BagDestinationHubName": this.cargohubitem.text
        })
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'getPendingBagsForScheduleTrip',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            this.isLoadingBags = false
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.PendingScheduleBagsList = result.data.ResponseData
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoadingBags = false
            console.error(error)
          })
      }
    },
    getPendingShipments() {
      if (this.ecomhubname == '') {
        this.ecomhubnameError = " Select Hub Name"
        return false;
      } else {
        this.ecomhubnameError = ''
        this.isLoadingShipments = true
        this.PendingScheduleShipmentsList = []
        this.input = ({
          "currentHubId": this.hubid[0],
          "connectionId": this.schedulesList.connectionid,
          "bagDestinationHubId": this.ecomhubitem.id,
          "stopPointHubId": this.tchPointHubId,
          "destinationHubId": this.ecomhubitem.id
        })
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'getPendingScheduleBagShipmentsList',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            this.isLoadingShipments = false
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.PendingScheduleShipmentsList = result.data.ResponseData
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoadingShipments = false
            console.error(error)
          })
      }
    },

    // //for paper Work
    getPendingWorkBagList() {
      this.showList = true
      window.scrollTo(0, 1000);
      this.input = {
        "ConnectionScheduleMasterId": this.schedulesList.connectionschedulemasterid,
        "CurrentHubId": this.hubid[0],
        "StopPointHubId": this.tchPointHubId,
        "ConnectionId": this.schedulesList.connectionid,
        "Status": "Pending",
        "ListType": "Cargo"
      }
      this.isLoadingParentMPS = true
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'getTripBagsList',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingParentMPS = false
          if (result.data.ResultCode == 100) {
            this.PendingParentMPSDetailsList = result.data.ResponseData
          } else {
            this.PendingParentMPSDetailsList = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoadingParentMPS = false
          console.error(error)
        })
    },
    closePendingWorkBagList() {
      this.showList = false
    },
    openPaperWorkCard() {
      this.isInscanSuccess=false
      this.IsPaperWorkBag = true
      this.isRemoveEvent    = false;
      this.isAWBRemoveEvent = false;
      this.paperno          = '';
      this.PaperNoError     = '';
      this.parentAWB        = '';
      this.parentAWBError   = '';
      this.childAWB         = '';
      this.childAWBError    = '';
      window.scrollTo(0, 1000);
      this.getPaperBagData();
    },
    getPaperBagData() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getParentBagsByConnectionScheduleMasterId?connectionScheduleMasterId=' + this.schedulesList.connectionschedulemasterid + "&connectionId=" + this.schedulesList.connectionid + "&stopPointHubId=" + this.tchPointHubId + "&currentHubId=" + this.hubid[0],
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
            if (result.data.ResultCode == 100) {
              this.isExistBag = true
              this.isBagData = true
              this.paperstatus = result.data.ResponseData.paperstatus
              this.vehiclecapacity = result.data.ResponseData.vehileCapacity
              this.vehiclecurrentload = result.data.ResponseData.vehicleCurrentLoad
              this.ExpectedB2BWeight = result.data.ResponseData.ExpectedB2BWeight
              this.vehicleavailablecapacity = result.data.ResponseData.vehicleAvailableCapacity
              this.listpaperbagno = result.data.ResponseData.paperbagno
              this.paperbagno = this.listpaperbagno
              this.IsPaperNo = true
              this.isReloadTable = true
              this.invalidTokenModal = false
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.isExistBag = false
              this.IsPaperNo = false
              this.isBagData = false
              this.paperstatus = ''
              this.vehiclecapacity = ''
              this.vehiclecurrentload = ''
              this.ExpectedB2BWeight = 0
              this.vehicleavailablecapacity = ''
              this.listpaperbagno = ''
              this.paperbagno = ''
              this.isReloadTable = false
            }
          },
          error => {
            console.error(error)
          })
    },
    closePaperWorkCard() {
      this.isInscanSuccess = false
      this.IsPaperWorkBag = false
      this.resetPaperBagNo()
    },
    clearPaperBagNoError() {
      if (this.paperbagno == '') {
        this.PaperBagNoError = 'The Bag No field is required.'
      } else {
        this.PaperBagNoError = ''
      }
    },
    generatePaperBagNo() {
      if (this.paperbagno == '') {
        this.PaperBagNoError = 'The Bag No field is required.'
        return false;
      } else {
        this.PaperBagNoError = ''
        this.input = ({
          "paperBagNo": this.paperbagno.trim(),
          "stopPointHubId": this.tchPointHubId,
          "isParentBag": true,
          "connectionScheduleMasterId": this.schedulesList.connectionschedulemasterid,
          "connectionId": this.schedulesList.connectionid,
          "isActive": true,
          "createdBy": this.useremail,
          "isRequired": false,
          "reason": "test", //optional
          "currentHubId": this.hubid[0],
          "currentHubName": this.hubName,
          "stopPointHubName": this.tchPointHubName,
          "isManualEntry":this.manualInscan,
          "statusMarkedFrom":"WEB",
        })
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'generatePaperLessWorkBagNo',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
              if (result.data.ResultCode == 100) {
                this.invalidTokenModal = false
                this.manualInscan=false
                this.$alertify.success(result.data.ReturnMessage)
                this.getPaperBagData();
                this.isReloadTable = true
              } else if (result.data.ResultCode == 401) {
                this.invalidTokenModal = true
                this.invalidtokenmsg = result.data.ReturnMessage
                this.$alertify.error(result.data.ReturnMessage)
              } else {
                this.invalidTokenModal = false
                this.isReloadTable = false
                this.isBagData = false
                this.$alertify.error(result.data.ReturnMessage)
              }
              if (result.data.ResultCode == 100 || result.data.ResponseData.paperstatus == 'BagOpen') {
                this.isExistBag = true
                this.isBagData = true
                this.invalidTokenModal = false
                this.paperstatus = result.data.ResponseData.paperstatus
                this.vehiclecapacity = result.data.ResponseData.vehileCapacity
                this.vehiclecurrentload = result.data.ResponseData.vehicleCurrentLoad
                this.ExpectedB2BWeight = result.data.ResponseData.ExpectedB2BWeight
                this.vehicleavailablecapacity = result.data.ResponseData.vehicleAvailableCapacity
                this.listpaperbagno = result.data.ResponseData.paperbagno
                this.paperbagno = this.listpaperbagno
                this.IsPaperNo = true
                this.isReloadTable = true
                this.manualInscan=false
              } else {
                this.invalidTokenModal = false
                this.IsPaperNo = false
                this.isBagData = false
                this.paperstatus = ''
                this.vehiclecapacity = ''
                this.vehiclecurrentload = ''
                this.ExpectedB2BWeight = 0
                this.vehicleavailablecapacity = ''
                this.listpaperbagno = ''
                this.paperbagno = ''
                this.isReloadTable = false
              }
            },
            error => {
              this.isReloadTable = false
              console.error(error)
            })
      }
    },

    getGeneratedPaperBagNoDetails(isRemove) {
      this.generatedPaperBagNoDetails = []
      this.input = ({
        "paperBagNo": this.paperbagno.trim()
      })
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'getPaperWorkDetailsByPaperBagNo',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.generatedPaperBagNoDetails = result.data.ResponseData
              if (isRemove != 1) {
                this.$alertify.success(result.data.ReturnMessage)
              }
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              if (isRemove != 1) {
                this.$alertify.error(result.data.ReturnMessage)
              }
            }
          },
          error => {
            console.error(error)
          })
    },
    RemoveRow(paperbagno) {
      if (!this.parentAWB) {
        this.parentAWBError = 'The Parent AWB field is required.'; return;
      }
      this.parentAWBError = '';
      this.isRemoveRowLoader = true;
      
      this.input = ({
        "parentMPS": this.parentAWB.trim(),
        "paperBagNo": paperbagno.trim(),
        "modifiedBy": this.useremail,
        "statusMarkedFrom": "WEB"
      })
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'removeParentMPS',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
            this.isRemoveRowLoader = false;
            if (result.data.ResultCode == 100) {
              this.parentAWB = '';
              this.invalidTokenModal = false
              this.$alertify.success(result.data.ReturnMessage)
              this.getGeneratedPaperBagNoDetails(1)
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.$alertify.error(result.data.ReturnMessage)
            }
            this.parentAWB = '';
          },
          error => {
            this.isRemoveRowLoader = false;
            console.error(error)
          })
    },
    clearPaperNoError() {
      if (this.paperno == '') {
        this.PaperNoError = 'The Parent AWB field is required.'
      } else {
        this.PaperNoError = ''
      }
    },
    inscanPaperNo() {
      if (this.IsAllow == true && this.isfullcapacity == false) {
        this.cargoallowSchedule = true
        this.isallowload = false
      } else if (this.IsAllow == true && this.isfullcapacity == true) {
        this.isallowload = true
        this.cargoallowSchedule = false
      } else {
        this.cargoallowSchedule = false
        this.isallowload = false
      }
      if (this.paperno == '') {
        this.PaperNoError = 'The Parent AWB field is required.'
        return false;
      } else {
        this.PaperNoError = ''
        this.isInscanSuccess=true

        this.input = ({
          "paperBagNo": this.paperbagno.trim(),
          "paperNo": this.paperno.trim(),
          "isActive": true,
          "isParentMPSRequired": true,
          "StopPointHubId": this.tchPointHubId,
          "allowSchedule": this.cargoallowSchedule,
          "isAllowExceedWeight": this.isallowload,
          "tripId": this.schedulesList.tripid,
          "connectionScheduleMasterId": this.schedulesList.connectionschedulemasterid,
          "createdBy": this.useremail,
          "isManualEntry":this.manualInscan,
          "statusMarkedFrom":"WEB",
        })
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'paperworkBagin',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
              if (result.data.ResultCode == 100) {
                this.isInscanSuccess=false
                this.invalidTokenModal = false
                // this.fullErrorMessage = result.data.ReturnMessage
                this.$alertify.success(result.data.ReturnMessage)
                this.paperno = ''
                this.manualInscan=false
                this.$validator.reset()
                //this.cargolimitexceedmodal = false
              } else if (result.data.ResultCode == 106) {
                this.isInscanSuccess=false
                this.invalidTokenModal = false
                this.cargolimitexceedmodal = true
                this.isfullcapacity = false
                this.cargolimitexceedmsg = result.data.ReturnMessage
              } else if (result.data.ResultCode == 104) {
                this.isInscanSuccess=false
                this.invalidTokenModal = false
                this.cargolimitexceedmodal = true
                this.isfullcapacity = true
                this.cargolimitexceedmsg = result.data.ReturnMessage
              } else if (result.data.ResultCode == 401) {
                this.isInscanSuccess=false
                this.invalidTokenModal = true
                this.invalidtokenmsg = result.data.ReturnMessage
                this.$alertify.error(result.data.ReturnMessage)
              } else if (result.data.ResultCode == 107) {
                this.isInscanSuccess=false
                this.$alertify.error(result.data.ReturnMessage)
                this.$router.push({
                  path: "AWBVerificationDimWt",
                  query: {
                    AWBNo: this.paperno.trim()
                  }
                })
              } else {
                //this.cargolimitexceedmodal = false
                this.isInscanSuccess=false
                this.invalidTokenModal = false
                this.$toast.error(result.data.ReturnMessage, { timeout: 10000, position: 'bottom-right' });
              }
            },
            error => {
              this.cargolimitexceedmodal = false
              console.error(error)
            })
      }
    },
    closeLimitExceedModal() {
      this.cargolimitexceedmodal = false
      this.isfullcapacity = false
      this.cargolimitexceedmsg = ''
    },
    getPendingScheduledBagCount() {
      if (this.IsScheduleListData == true) {
        axios({
            'method': 'GET',
            'url': apiUrl.api_url_hubops + 'getTripBagsCount?ConnectionScheduleMasterId=' + this.schedulesList.connectionschedulemasterid + '&CurrentHubId=' + this.hubid[0] + '&StopPointHubId=' + this.tchPointHubId + '&ConnectionId=' + this.schedulesList.connectionid,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
              'requestfrom': "WEB",
              'token': this.token
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.invalidTokenModal = false
              this.PendingBagsCount = result.data.PendingBagsCount;
              this.ScheduledBagsCount = result.data.ScheduledBagsCount;
            } else if (result.data.ResultCode == 401) {
              this.invalidTokenModal = true
              this.invalidtokenmsg = result.data.ReturnMessage
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.invalidTokenModal = false
              this.InScannedBagsCount = ''
              this.InScannedBagsCount = ''
            }
          }, error => {
            console.error(error);
          })
      } else {
        this.$alertify.error("No Data Found");
      }
    },
    getCargoPendingList() {
      this.isLoadingSearchForCargoPending=true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getPendingAndScheduledCount?connectionschedulemasterid=' + this.schedulesList.connectionschedulemasterid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          this.pendingMpsCount = [];
          this.isLoadingSearchForCargoPending=false;
        if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.pendingMpsCount = result.data.ResponseData;
            this.showModalForCargoPendingList = true;
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
            this.showModalForCargoPendingList = false;
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
            this.showModalForCargoPendingList = false;
          }
        }, error => {
          console.error(error);
        })
    },
    ShowMPSInscanFunction(data) {
      this.$validator.reset();
      this.ShowMPSInscan = true;
      this.parentawb = data.parentawb
      this.paperbagnum = data.paperbagno
      this.childmps = ''
      this.showValidationMSG = false
    },
    offloadMPS() {
      if (this.parentawb == '') {
        this.showValidationMSG = true
        return false
      }
      if (this.childmps == '') {
        return false
      }
      this.input = ({
        "PaperBagNo": this.paperbagnum,
        "ChildMPS": this.childmps,
        "ParentAWB": this.parentawb,
        "CurrentHubId": this.hubid[0],
        "LastModifiedBy": this.useremail,
        "ConnectionScheduleMasterId": this.schedulesList.connectionschedulemasterid,
        "isManualEntry": this.manualInput
      })
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'offloadParentChildMPSFromList',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.invalidTokenModal = false
            this.manualInput = false
            this.$alertify.success(result.data.ReturnMessage)
            this.getCargoPendingList();
            this.childmps = ''
            this.parentawb = ''
            this.showValidationMSG = false
            this.$validator.reset();
            // this.resetAll();
          } else if (result.data.ResultCode == 401) {
            this.invalidTokenModal = true
            this.invalidtokenmsg = result.data.ReturnMessage
            this.$alertify.error(result.data.ReturnMessage)
          } else {
            this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
            this.childmps = ''
            this.showValidationMSG = false
            this.$validator.reset();
          }
        }, error => {
          console.error(error)
        })
    },
    closeModal() {
      this.showModal = false;
      this.showMultipartShipmentModal = false;
      this.multipartShipmentData=[];
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },

    closeModalforbag() {
      this.showMultipartBagModal = false;
      this.multipartBagData=[];
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },

    closeModalForConfConn() {
      this.showTripConfConnModel = false;
      this.tripConfConnData=[];
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    resetPaperBagNo() {
      this.isBagData = false
      this.isInscanSuccess = false
      this.paperstatus = ''
      this.vehiclecapacity = ''
      this.vehiclecurrentload = ''
      this.ExpectedB2BWeight = 0
      this.vehicleavailablecapacity = ''
      this.listpaperbagno = ''
      this.paperbagno = ''
      this.PaperBagNoError = ''
      this.paperno = ''
      this.manualInscan=false
      this.PaperNoError = ''
      this.IsPaperNo = false
      this.isReloadTable = false
      this.isExistBag = false
      this.IsAllow = false
      this.cargolimitexceedmodal = false
      this.isfullcapacity = false
      this.generatedPaperBagNoDetails = []
      // this.fullErrorMessage = ''
    },
    validatebuttons(){
      let result = false
      for (let i = 0; i < this.vehiclesealdata.sealprefix.length; i++) {
        if (this.VehicleSealNo.toLowerCase().startsWith(this.vehiclesealdata.sealprefix[i].toLowerCase())) {
            result = true;
            break;
          }
        }
      return result;
    },
  /* HUB-4043 Outscan And Pending Count Code Started Here*/
    /* get paper bag pending and outscanned count from API */
    getPaperBagCount() {
      this.isLoadingSearch = true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getPaperBagCount?csmid=' + this.schedulesList.connectionschedulemasterid + '&currenthubid=' + this.hubid + '&type=outbound' + '&isConnectionRestricted=' + this.isConnectionRestricted+ '&isHubRestricted=' + this.isHubRestricted,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.PendingCount = result.data.ResultData.PendingCount;
            this.OutScanCount = result.data.ResultData.OutScanCount;
          } else{
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.isLoadingSearch = false;
        }, error => {
          this.isLoadingSearch = false;
          console.error(error);
        })
    },

      /* get paper bag outscanned details of that paper bag from API */
    getOutscanPaperBagDetails() {
      this.isLoadingSearch = true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getOutScannedPaperBags?csmid=' + this.schedulesList.connectionschedulemasterid + '&currenthubid=' + this.hubid + '&type=outbound',
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CountDetails = result.data.ResponseData;
            this.PaperBagPendingOutscanListModel = true;
          } else{
            this.PaperBagPendingOutscanListModel = false;
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.isLoadingSearch = false;
        }, error => {
          this.isLoadingSearch = false;
          console.error(error);
        })
    },

    /* get paper bag Pending details of that paper bag from API */
    getPendingPaperBagDetails() {
      this.isLoadingSearch = true;
      axios({
          'method': 'GET',
          'url': apiUrl.api_url_hubops + 'getPendingPaperBags?csmid=' + this.schedulesList.connectionschedulemasterid + '&currenthubid=' + this.hubid + '&type=outbound' + '&isConnectionRestricted=' + this.isConnectionRestricted+ '&isHubRestricted=' + this.isHubRestricted,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.CountDetails = result.data.ResponseData;
            this.PaperBagPendingOutscanListModel = true;
          } else{
            this.PaperBagPendingOutscanListModel = false;
            this.$alertify.error(result.data.ReturnMessage)
          }
          this.isLoadingSearch = false;
        }, error => {
          this.isLoadingSearch = false;
          console.error(error);
        })
    },

    closePaperBagPendingOutscanListModel() {
      this.PaperBagPendingOutscanListModel = false;
    },

    closeRemoveParentAWBCard() {
      this.isRemoveEvent    = false;
      this.isAWBRemoveEvent = false;
      this.parentAWB        = '';
      this.parentAWBError   = '';
    },

    openParentAWBCard() {
      this.isRemoveEvent = true;

      this.$nextTick(() => {
        if (this.$refs.perentAWB) {
          this.$refs.perentAWB.focus();
        }
      });
    },

    openRemoveMPSCard() {
      this.childAWB         = '';
      this.childAWBError    = '';
      this.isRemoveEvent    = false;
      this.IsPaperWorkBag   = true;
      this.isAWBRemoveEvent = true;

      this.$nextTick(() => {
        if (this.$refs.childAWB) {
          this.$refs.childAWB.focus();
        }
      });
    },

    getIsDockMandatory(){
    this.dockLoading = true;
     axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/isDockMandatory?hubId=' + this.hubid,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        if (result.data.ResultCode == 100) {
         this.isDockMandatory = result.data.ResponseData.is_mandatory
         if(this.isDockMandatory){
          this.getDockList();
          this.checkDockIn();
         } else {
          this.dockLoading = false;
         }
        }
        else{
          this.dockLoading = false;
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error);
        this.dockLoading = false;
      });

  },

  
  getDockList() {
      this.dockList = [];
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/dockList?hubId=' + this.hubid,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        this.dockLoading = false;
        if (result.data.ResultCode == 100) {
          result.data.ResponseData.forEach(item => {
            this.dockList.push({ value: item.dock_barcode, text: item.dock_id });
          });
        }
        else{
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error);
        this.dockLoading = false;
      });
    },
      getDockChangeReason() {
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/dockReasons?type=dock_change_reasons',
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        console.log("result",result)
        if (result.data.ResultCode == 100) {
          this.getDockChangeReasonList = result.data.ResponseData.map(r => ({ value: r.id, text: r.reason }));
        }
        else{
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => { console.error(error); });
    },

    selectDock(selectedData) {
      this.selectedDock = selectedData;
      this.dockId = selectedData.text;
      this.dockbarcode = selectedData.value;
      this.scannedDockBarcode = selectedData.value;
      this.dockIdError = false;
    },

    onDockBarcodeScan() {
      const value = this.scannedDockBarcode ? String(this.scannedDockBarcode).trim() : '';
      if (!value) {
        this.dockbarcode = '';
        this.dockId = '';
        this.selectedDock = { value: '', text: '' };
        return;
      }
      const match = this.dockList.find(d => String(d.value).trim() === value);
      this.dockbarcode = value;
      this.dockId = match ? match.text : value;
      this.selectedDock = match ? match : { value: '', text: '' };
      this.dockIdError = false;
    },

    focusScanDockInput() {
      this.$nextTick(() => {
        if (this.$refs.scanDockInput && typeof this.$refs.scanDockInput.focus === 'function') {
          this.$refs.scanDockInput.focus();
        }
      });
    },

    focusNewDockScanInput() {
      this.$nextTick(() => {
        if (this.$refs.scanNewDockInput && typeof this.$refs.scanNewDockInput.focus === 'function') {
          this.$refs.scanNewDockInput.focus();
        }
      });
    },

    onNewDockBarcodeScan() {
      const value = this.newScannedDockBarcode ? String(this.newScannedDockBarcode).trim() : '';
      if (!value) {
        this.newDockBarcode = '';
        this.newDockId = '';
        this.newDockSelected = { value: '', text: '' };
        return;
      }
      const match = this.dockList.find(d => String(d.value).trim() === value);
      this.newDockBarcode = value;
      this.newDockId = match ? match.text : value;
      this.newDockSelected = match ? match : { value: '', text: '' };
      this.newDockIdError = false;
    },

    checkDockIn() {
      let vehicleNumber = this.schedulesList.vehicleno;
      if (!vehicleNumber) {
        // HUB: never leave the dock loader stuck if we bail out before firing the request
        this.dockLoading = false;
        return;
      }
      axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'dockmaster/checkDockIn?hubId=' + this.hubid[0] + '&vehicleNumber=' + vehicleNumber,
        headers: { 'authorization': 'authkey xB84JJ89Hd25' }
      }).then(result => {
        // HUB: clear loader here too so the dock section renders even if getDockList() hangs or errors
        this.dockLoading = false;
        if (result.data.ResultCode == 100 && result.data.ResponseData.is_docked_in) {
          this.dockbarcode = result.data.ResponseData.dock_barcode;
          this.dockId = result.data.ResponseData.dock_id;
          this.selectedDock = { value: result.data.ResponseData.dock_barcode, text: result.data.ResponseData.dock_id };
          // HUB: retain the auto-loaded scanned barcode in the input when returning to the page after dock-in
          this.scannedDockBarcode = result.data.ResponseData.dock_barcode;
          this.isDockIn = true;
          this.$alertify.success("Already Dock-In at " + result.data.ResponseData.dock_barcode);
        }
      }, error => {
        this.dockLoading = false;
        console.error(error);
      });
    },

    validateBarcode(barcode, target /* 'primary' | 'new' */) {
      return new Promise((resolve) => {
        if (!barcode) { resolve({ ok: false, reason: 'empty' }); return; }
        axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'dockmaster/validateBarcode',
          data: {
            dock_barcode: String(barcode).trim(),
            hub_id: Number(this.hubid[0]),
          },
          headers: { 'authorization': 'authkey xB84JJ89Hd25' }
        }).then(result => {
          const data = (result && result.data) || {};
          const resp = data.ResponseData || {};
          if (data.ResultCode == 100 && resp.dock_id) {
            // Populate target vars whenever the barcode resolves to a
            // real dock at this hub (even at full capacity). Capacity
            // enforcement is signalled via `ok: false, reason: 'full'`
            // so click-time callers still early-abort on full docks.
            // See sibling `CenterScanInTrip.validateBarcode` for the
            // full rationale.
            if (target === 'primary') {
              this.dockbarcode = barcode;
              this.dockId = resp.dock_id;
              this.selectedDock = { value: barcode, text: resp.dock_id };
              this.scannedDockBarcode = barcode;
              this.dockIdError = false;
            } else {
              this.newDockBarcode = barcode;
              this.newDockId = resp.dock_id;
              this.newDockSelected = { value: barcode, text: resp.dock_id };
              this.newScannedDockBarcode = barcode;
              this.newDockIdError = false;
            }
            if (resp.is_available === false) {
              this.$alertify.error(data.ReturnMessage || 'Dock is at full capacity.');
              resolve({ ok: false, valid: true, reason: 'full', dock_id: resp.dock_id });
              return;
            }
            resolve({ ok: true, valid: true, dock_id: resp.dock_id });
          } else {
            this.$alertify.error(data.ReturnMessage || 'Invalid dock barcode.');
            resolve({ ok: false, valid: false, reason: 'invalid' });
          }
        }, err => {
          console.error(err);
          this.$alertify.error('Dock barcode validation failed.');
          resolve({ ok: false, valid: false, reason: 'error' });
        });
      });
    },

        async dockIn() {
      if (!this.dockbarcode) {
        this.dockIdError = true;
        return;
      }

      const { ok: isValid } = await this.validateBarcode(this.dockbarcode, 'primary');
      if (!isValid) return;

       let vehicleNumber = this.schedulesList.vehicleno;
      this.input = { 
        dock_barcode: this.dockbarcode, 
        hub_id: this.hubid[0], 
        vehicle_number:vehicleNumber,
        operation_type:"Midmile_Outbound",
        trip_id: this.schedulesList.tripid.toString(),
        dock_in_by:this.useremail,
        override_reason:""
        };
      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'dockmaster/dockIn',
        data: this.input,
        headers: { 'authorization': 'authkey xB84JJ89Hd25'}
      }).then(result => {
        if (result.data.ResultCode == 100) {
          this.isDockIn = true;
          this.$alertify.success(result.data.ReturnMessage);
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => { this.$alertify.error('Dock-In API Error'); });
    },

    openChangeDockModal() {
      this.getDockChangeReason();
      this.getDockList();
      this.showChangeDockModal = true;
      this.newDockId = '';
      this.newDockBarcode = '';
      this.newDockSelected = { value: '', text: '' };
      this.newScannedDockBarcode = '';
      this.changeDockReason = '';
      this.selectedDockChangeReason = { value: '', text: '' };
      this.selectedDockChangeReasonError = '';
      this.newDockIdError = false;
      this.changeDockReasonError = false;
    },

    closeChangeDockModal() {
      this.showChangeDockModal = false;
    },

    selectNewDock(selectedData) {
      this.newDockSelected = selectedData;
      this.newDockId = selectedData.text;
      this.newDockBarcode = selectedData.value;
      this.newScannedDockBarcode = selectedData.value;
      this.newDockIdError = false;
    },
    selectReasonForNewDock(selectedData) {
      this.selectedDockChangeReason = selectedData;
      console.log("selected",this.selectedReason)
      this.selectedDockChangeReasonError = false;
    },

    async saveDockChange() {
      // Validate all required fields
      let isValid = true;

      if (!this.newDockBarcode || this.newDockBarcode === '') {
        this.newDockIdError = true;
        isValid = false;
      }

      if (!this.selectedDockChangeReason || !this.selectedDockChangeReason.value) {
        this.selectedDockChangeReasonError = true;
        isValid = false;
      }

      if (!isValid) return;

      const { ok: isDockValid } = await this.validateBarcode(this.newDockBarcode, 'new');
      if (!isDockValid) return;

      let vehicleNumber = this.schedulesList.vehicleno;


      this.input = {
        vehicle_number: vehicleNumber,
        new_dock_barcode: this.newDockBarcode,
        hub_id: this.hubid[0],
        modifiedBy: this.useremail,
        reason:this.selectedDockChangeReason.text,
        status_marked_from: 'WEB'

      };

      axios({
        method: 'POST',
        url: apiUrl.api_url_hubops + 'dockmaster/changeDock',
        data: this.input,
        headers: { 'authorization': 'authkey xB84JJ89Hd25'}
      }).then(result => {
        if (result.data.ResultCode == 100) {
          this.dockId = this.newDockId;
          this.dockbarcode = this.newDockBarcode;
          this.scannedDockBarcode = this.newDockBarcode;
          this.selectedDock = { value: this.newDockBarcode, text: this.newDockId };
          this.showChangeDockModal = false;
          this.$alertify.success(result.data.ReturnMessage);
          this.resetChangeDockForm();
        } else {
          this.$alertify.error(result.data.ReturnMessage);
        }
      }, error => { this.$alertify.error('Change Dock API Error'); });
    },

  resetChangeDockForm() {
      this.newDockId = '';
      this.newDockBarcode = '';
      this.newDockSelected = { value: '', text: '' };
      this.newScannedDockBarcode = '';
      this.selectedDockChangeReason = { value: '', text: '' };
      this.selectedDockChangeReasonError = '';
      this.changeDockReason = '';
      this.newDockIdError = false;
      this.changeDockReasonError = false;
      if (this.showChangeDockModal) this.focusNewDockScanInput();
    },

 resetDock() {
  this.selectedDock = { value: '', text: '' };
  this.dockId = '';
  this.dockbarcode = '';
  this.scannedDockBarcode = '';
  this.dockIdError = false;
  if (this.isDockMandatory) this.focusScanDockInput();
 }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/NetworkManagement/GenerateTripSheet/GenerateTripSheet.js